import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const BlogCard = ({ blog, index }) => {
    // Check if blog is undefined or null
    if (!blog) {
        return (
            <motion.div
                className="col-md-4 mb-4"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
            >
                <div className="card blog-card h-100">
                    <div className="card-body text-center p-4">
                        <i className="fas fa-exclamation-circle fa-2x text-muted mb-3"></i>
                        <h5 className="card-title">Blog Post Not Available</h5>
                        <p className="card-text text-muted">This content is currently unavailable.</p>
                    </div>
                </div>
            </motion.div>
        );
    }

    // Use safe access with default values
    const image = blog.image || 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80';
    const title = blog.title || 'Untitled Blog Post';
    const excerpt = blog.excerpt || 'No description available.';
    const category = blog.category || 'General';
    const date = blog.date || 'Date not available';
    const id = blog.id || 0;

    return (
        <motion.div
            className="col-md-4 mb-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
        >
            <div className="card blog-card h-100">
                <img
                    src={image}
                    className="card-img-top blog-image"
                    alt={title}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80';
                    }}
                />
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary-red">{category}</span>
                        <small className="text-muted">{date}</small>
                    </div>
                    <h5 className="card-title mb-3">{title}</h5>
                    <p className="card-text text-muted">{excerpt}</p>
                    <div className="mt-auto">
                        <Link to={`/blog/${id}`} className="btn btn-outline-custom">
                            Read More <i className="fas fa-arrow-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default BlogCard;